import React, {FC} from 'react';
import {Col, Row} from 'antd';
import {ColProps} from 'antd/lib/grid';

interface FloatedColProps extends ColProps {
    justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between';
    align?: 'top' | 'middle' | 'bottom' | 'stretch';
}

export const FloatedCol: FC<FloatedColProps> = ({justify, align, ...rest}) => {
    return (
        <Col {...rest}>
            <Row align={align || 'middle'} justify={justify}>
                {rest.children}
            </Row>
        </Col>
    );
};
